import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polygon
    points="16.76 35.45 25.9 48.02 47.83 48.11 47.83 24.11 31.84 9.81 16.76 35.45"
    {...props}
  />
);

const AvatarArtworkStorm = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.AVATAR_10}
    renderShadow={renderShadow}
  >
    <>
      <polygon
        points="32.79 23.45 31.31 22.53 36.13 14.8 40.36 12.94 40.36 10.06 45.2 7.88 45.92 9.47 42.1 11.19 42.1 14.08 37.32 16.18 32.79 23.45"
        style={{ fill: '#e1e5ff' }}
      />
      <polygon
        points="15.3 16.28 7.88 14.48 8.91 8.34 5.4 7.64 5.76 5.83 11.02 6.89 9.97 13.1 15.73 14.49 15.3 16.28"
        style={{ fill: '#e1e5ff' }}
      />
      <polygon
        points="25.47 20.88 14.56 6.14 17.47 3.42 13.82 2.27 14.35 0.61 20.85 2.66 16.89 6.35 26.87 19.84 25.47 20.88"
        style={{ fill: '#e1e5ff' }}
      />
      <path
        d="M24.74,12.37h-.06a.28.28,0,0,1-.22-.34l.26-1.17a.3.3,0,0,1,.12-.17l1.24-.87a.29.29,0,0,1,.33.47l-1.15.81L25,12.14A.28.28,0,0,1,24.74,12.37Z"
        style={{ fill: '#d9d6dc' }}
      />
      <polygon
        points="24.87 26.41 23.4 25.47 33.56 9.68 29.59 5.99 32.8 0 34.34 0.82 31.77 5.63 35.82 9.39 24.87 26.41"
        style={{ fill: '#e1e5ff' }}
      />
      <path
        d="M29.11,14.76H17.73l-4.54,6.39,2,10.87a4.91,4.91,0,0,0,1.66,3.32l3.66,3.18a4.39,4.39,0,0,0,5.82,0L30,35.34A4.9,4.9,0,0,0,31.65,32l2-10.87Z"
        style={{ fill: '#ad785e' }}
      />
      <path
        d="M15.84,21.75s2.57-2.73,3.54-2.61,11.4,2.61,11.4,2.61l2.75-3.25a6.19,6.19,0,0,0,1-3.23c-.11-1.59-2.58-5.56-2.58-5.56S30.53,11.64,30,11.64s-.75-3.4-.75-3.4-1.71,1.91-2.36,2.06S24.53,7,24.53,7l-.93,3.54L21.23,7.48,20,10.42l-1-2.18s-3.83,4-3.84,6.15c0,1-1.63-2-1.63-2S12,16.15,13.1,18.5A20.23,20.23,0,0,0,15.84,21.75Z"
        style={{ fill: '#d9d6dc' }}
      />
      <path
        d="M30.78,22h-.06c-.11,0-10.44-2.48-11.38-2.6-.57-.08-2.26,1.43-3.29,2.51a.21.21,0,0,1-.21.09.3.3,0,0,1-.2-.08,19.84,19.84,0,0,1-2.81-3.33c-1.1-2.43.3-6.14.36-6.3a.29.29,0,0,1,.26-.19.31.31,0,0,1,.27.15,17.18,17.18,0,0,0,1.11,1.81c.36-2.3,3.74-5.89,3.89-6.05A.27.27,0,0,1,19,8a.29.29,0,0,1,.22.16l.75,1.61,1-2.35a.3.3,0,0,1,.23-.18.32.32,0,0,1,.27.11l2,2.62.78-3a.29.29,0,0,1,.25-.21.28.28,0,0,1,.29.16c.81,1.62,1.75,3,2.06,3.12A10.23,10.23,0,0,0,29,8,.3.3,0,0,1,29.34,8a.29.29,0,0,1,.19.26,10.77,10.77,0,0,0,.52,3.11,7.7,7.7,0,0,0,1.64-1.79.27.27,0,0,1,.24-.12.28.28,0,0,1,.24.13c.1.17,2.5,4,2.62,5.7a6.42,6.42,0,0,1-1,3.41L31,21.93A.26.26,0,0,1,30.78,22ZM19.32,18.85h.09c.91.11,9.86,2.23,11.27,2.56l2.63-3.11h0a5.91,5.91,0,0,0,.9-3c-.08-1.23-1.71-4.06-2.31-5.06-.57.75-1.39,1.7-1.91,1.7-.2,0-.73,0-1-3A6.88,6.88,0,0,1,27,10.58c-.61.14-1.55-1.28-2.33-2.75l-.74,2.81a.27.27,0,0,1-.22.21.27.27,0,0,1-.28-.11L21.3,8.05l-1.08,2.49a.3.3,0,0,1-.27.17h0a.29.29,0,0,1-.26-.16l-.84-1.8c-.88,1-3.46,4-3.47,5.64,0,.35-.16.46-.3.5s-.48.12-1.55-1.75c-.34,1.13-.92,3.58-.17,5.24a17,17,0,0,0,2.48,2.95C16.54,20.62,18.36,18.85,19.32,18.85Z"
        style={{ fill: '#9b9a98' }}
      />
      <path
        d="M20.63,35.24c-.18.3.24.63.83.79a7.49,7.49,0,0,0,2,.18A8.12,8.12,0,0,0,25.33,36c.56-.15,1-.42,1-.72a.14.14,0,0,0-.07-.09.78.78,0,0,0-.29-.06c-1.4-.11-2.82-.16-4.24-.15a4.09,4.09,0,0,0-.95.09"
        style={{ fill: '#895858' }}
      />
      <path
        d="M20.59,35.2a3.46,3.46,0,0,1,2.79-1.05,3.5,3.5,0,0,1,2.82,1s0,.06,0,.08a.15.15,0,0,1-.1,0c-.81,0-1.57-.2-2.59-.2a23.59,23.59,0,0,0-3,.24Z"
        style={{ fill: '#603134' }}
      />
      <path
        d="M14.75,29.09s-2.62-6.24-2.24-7.64a16.84,16.84,0,0,1,.9-2.5l2.68,2.5Z"
        style={{ fill: '#d9d6dc' }}
      />
      <path
        d="M14.75,29.36a.28.28,0,0,1-.26-.17c-.27-.64-2.64-6.36-2.25-7.81a18.06,18.06,0,0,1,.91-2.54.32.32,0,0,1,.2-.16.29.29,0,0,1,.25.07l2.68,2.5a.26.26,0,0,1,.08.25L15,29.13a.27.27,0,0,1-.24.23ZM13.5,19.43a17.9,17.9,0,0,0-.72,2.1c-.23.85.88,4.11,1.86,6.56l1.15-6.54Z"
        style={{ fill: '#9b9a98' }}
      />
      <path
        d="M32.27,29.09s2.38-6.24,2-7.64a18.3,18.3,0,0,0-.9-2.5l-2.68,2.5Z"
        style={{ fill: '#d9d6dc' }}
      />
      <path
        d="M32.27,29.36h0a.29.29,0,0,1-.25-.22l-1.58-7.63a.28.28,0,0,1,.08-.26l2.68-2.5a.29.29,0,0,1,.25-.07.28.28,0,0,1,.19.16,16.11,16.11,0,0,1,.92,2.54c.39,1.45-1.76,7.16-2,7.8A.27.27,0,0,1,32.27,29.36ZM31,21.55l1.35,6.53c.88-2.45,1.88-5.7,1.65-6.55a17.56,17.56,0,0,0-.73-2.1Z"
        style={{ fill: '#9b9a98' }}
      />
      <path
        d="M20.21,18.68a8.14,8.14,0,0,1-3.27,4.17,6.78,6.78,0,0,1-2.74-.25,10.53,10.53,0,0,0,2.69-2.92C17.87,18,20.21,18.68,20.21,18.68Z"
        style={{ fill: '#d9d6dc' }}
      />
      <path
        d="M16.33,23.23a9.76,9.76,0,0,1-2.21-.35.29.29,0,0,1-.21-.23.28.28,0,0,1,.12-.28,10.47,10.47,0,0,0,2.61-2.84c.86-1.5,2.77-1.39,3.66-1.13a.28.28,0,0,1,.17.15.26.26,0,0,1,0,.23,8.29,8.29,0,0,1-3.43,4.34A1.88,1.88,0,0,1,16.33,23.23Zm-1.48-.77a4.9,4.9,0,0,0,2,.13,8,8,0,0,0,3-3.71,2.48,2.48,0,0,0-2.68.94A10.51,10.51,0,0,1,14.85,22.46Z"
        style={{ fill: '#9b9a98' }}
      />
      <path
        d="M29.76,11.39a20.86,20.86,0,0,1,1,3.56,9.94,9.94,0,0,1-.23,3.17"
        style={{ fill: '#d9d6dc' }}
      />
      <path
        d="M30.49,18.41h-.07a.28.28,0,0,1-.21-.35A10,10,0,0,0,30.43,15a21.35,21.35,0,0,0-.94-3.5.28.28,0,0,1,.17-.37.29.29,0,0,1,.37.17,20.21,20.21,0,0,1,1,3.63,10.27,10.27,0,0,1-.23,3.27A.29.29,0,0,1,30.49,18.41Z"
        style={{ fill: '#9b9a98' }}
      />
      <path
        d="M15.09,14.39a9.93,9.93,0,0,0,.27,3.25"
        style={{ fill: '#d9d6dc' }}
      />
      <path
        d="M15.36,17.93a.29.29,0,0,1-.28-.21,10.36,10.36,0,0,1-.28-3.36.3.3,0,0,1,.32-.26.29.29,0,0,1,.26.31,9.94,9.94,0,0,0,.25,3.15.29.29,0,0,1-.19.36Z"
        style={{ fill: '#9b9a98' }}
      />
    </>
  </AvatarArtwork>
);

export default AvatarArtworkStorm;
